import * as Types from './ActionTypes';
import * as AdminServices from '../../../services/AdminServices';

export const authenticateUserAction = (status) => {
    return { type: Types.AUTHENTICATE_USER, payload: status };
};

export const createUserAction = (authUser) => {
    return { type: Types.CREATE_USER, payload: authUser };
};

export const clearAuthStateAction = () => {
    return { type: Types.CLEAR_AUTH_STATE, payload: [] };
};

export const redirectToHomeAction = () => {
    return { type: Types.REDIRECT_TO_HOME, payload: true };
};

export const authenticateUser = (user) => (
    (dispatch) => {
        return AdminServices.authenticateUser(user)
            .then((status) => {
                dispatch(authenticateUserAction(status));
            })
            .catch(error => console.log(error));
    }
);

export const createUser = (user) => (
    (dispatch) => {
        return AdminServices.createUser(user)
            .then(authUser => {
                console.log('authUser in action', authUser);
                dispatch(createUserAction(authUser));
            })
            .catch(error => console.log(error));
    }
);

